module.exports = __webpack_public_path__ + "static/img/caixa-economica-federal.6a17ea15.svg";